import { AutogenModelTieredChargeTable, AutogenRowTieredChargeTable } from "./autogen/AutogenModelTieredChargeTable";

export class ModelTieredChargeTable extends AutogenModelTieredChargeTable<RowTieredChargeTable> {
	constructor() {
		super(RowTieredChargeTable);
	}
}

export class RowTieredChargeTable extends AutogenRowTieredChargeTable {
}